import Api from "./Api.js";

const resource = "/payment-methods";

export default {
  get(params) {
    return Api.get(`${resource}`, { params });
  }
};
